import type { HTMLAttributes } from 'react';
import { cx } from '../cx.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** `ground`: card in rilievo con ombra (default). `surface`: card su surface, solo bordo. */
  on?: 'ground' | 'surface';
  /** Evidenziata su accent-soft (es. webinar di oggi). */
  highlighted?: boolean;
}

export function Card({ on = 'ground', highlighted, className, ...rest }: CardProps) {
  return (
    <div
      className={cx(
        'rounded-lg p-6',
        highlighted ? 'bg-accent-soft' : 'bg-surface',
        on === 'ground' && !highlighted ? 'shadow-card' : 'border border-border',
        className,
      )}
      {...rest}
    />
  );
}
